import { render, staticRenderFns } from "./button-page-edit-wrapper.vue?vue&type=template&id=2e2e925d&scoped=true&"
import script from "./button-page-edit-wrapper.vue?vue&type=script&lang=js&"
export * from "./button-page-edit-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./button-page-edit-wrapper.vue?vue&type=style&index=0&id=2e2e925d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e925d",
  null
  
)

export default component.exports